import React, { useEffect, useState, useMemo, useCallback } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import {
    bltReviewSelect
} from '../../../redux/selector/bltReviewSelector'
import { applicationData } from '../../../redux/selector/bltHomeSelector'
import {
    setConfirmSuretyBond,
    setAgencyApplicationStatus,
    updateBLTAgencyApplicationReviewItem,
    setAgencyApplication,
    setAgencyApplicationLicenceStatus,
    setInternalNoteList,
    setAgencyApplicationLocked,
    setCurrentMainAgentChangeRequestForApproval,
    setMortgageProperty,
    setAgencyDocumentsIsUpdatedReset
} from '../../../redux/slice/primaryAgencyApplicationSlice'
import {
    BLTNavigationTop,
    BLTScreenNavigation
} from '../BLTCommon/BLTNavigationTop'
import '../BLTHome/BLTHome.styles.scss'
import '../BLTReview/BLTReview.styles.scss'
import ReviewForm from '../../../components/ReviewForm/BLTReviewForm'
import BLTChangeReviewForm from '../../../components/ReviewForm/BLTChangeReviewForm'
import * as CONST from '../../../app/constants'
import { fullName, humanReadableDate, isBranchApplication, IsDateInFuture } from '../../../app/utils'
import { Button, ErrorMark, LineSeperator } from '../../../components/RegularComponents'
// import DateSelectionForm from "../../../components/DateSelectionForm"
import DateSelectionComponentsForm from "../../../components/DateSelectionComponentsForm"
import { push } from 'connected-react-router'
import { approveAndCancelApplicationData, markDeleteApplications, saveBusinessLicenceApplicationData } from '../../../redux/slice/businessLicenceApplicationSlice'
import { ERROR_STRING } from '../../../app/errors'
import DocumentViewer from '../../../components/DocumentViewer/DocumentViewer'
import {
    DocumentViewerFileNameLink,
    DownloadFileNameLink
} from '../../../components/DocumentViewer/DocumentFileComponent'
import { fetchDocumentData } from '../../../redux/slice/supportingDocumentsSlice'
import {
    // sendCollectorApplicationStatus, 
    resetQueue,
    fetchPrincipalBrokerWithBusinessApplicationId,
    sendBrokerApplicationStatus,
    sendBranchAndCollectorApplicationStatus
} from '../../../redux/slice/bltHomeSlice'
import { useParams } from "react-router-dom"
import { fetchApplicationWithId } from '../../../redux/slice/bltHomeSlice';
import ApplicationStatusComponent from '../BLTCommon/ApplicationStatus'
import {
    updateBLTAgentApplicationReviewItem,
    setCurrentAgentApplicationStatus,
    setCurrentAgentLicenceStatus,
    setCurrentCollectorCompanyRjscDetails,
    setCurrentCollectorCompanyTrademark,
    setCurrentAgentInternalNoteList,
    setCurrentAgentRegulatoryInformationReceivedDate,
    setCurrentAgentApplicationLocked,
    setCurrentBranchApplicationStatus,
    setCurrentBranchApplicationLicenceStatus,
    setCurrentBranchApplicationLocked,
    updateBLTBranchApplicationReviewItem,
    setCurrentAgentMortgageProperty,
    setCurrentAgentDocumentsIsUpdatedReset,
    setCurrentAgentLicenceExpiryDate,
    setCurrentBranchApplicationInternalNotes,
} from '../../../redux/slice/additionalApplicationsSlice'
import { convertFileDataForUrl, getDocumentTypeName } from '../../../app/documentUploadUtils'
import {
    getApplicationById,
    handleMortgageBrokerageRenewalReview,
    handleMortgagePrincipalBrokerRenewalReview,
    handlePostAgencyReviewProcess,
    legalNameTitle,
    mainTitle,
    mediumTitle,
    subTitle
} from './BLTReviewUtils'
import {
    applicationTypeFromLicenceSubType,
    isAgencyTypeApplication,
    isApplicationProcessed,
    isApplicationProcessingInProgress,
    isChangeRequestTypeApplication,
    isIndividaulPrincipalBrokerApplication,
    isIndividualTypeApplication,
    isMortgageMainAgentTypeApplication,
    isMortgageTypeApplication,
    isRenewalTypeApplication
} from '../../../redux/slice/applicationsUtils'
import LicenceWithdrawalConfirmation from './LicenceWithdrawalConfirmation'
import LicenceUpgradeWithdrawConfirmation from './LicenceUpgradeWithdrawConfirmation'

import { convertAdditionalBranchRenewalDataFromServer } from '../../../redux/selector/BLTReviewData/collectionsReviewData'
import { APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE } from '../../../app/constants'
import { sendEmail } from '../../../redux/slice/bltDecisionSlice'
import AgentApplicationApprovalConfirmation from './AgentApplicationApprovalConfirmation'
import { isHavingUpdatedDocuments } from '../../../redux/selector/BLTReviewData/bltReviewMortgageApplication'



const applicantInformationMapRJSC = {
    "Officials with RJSC": true,
    "Registry ID": true,
    "Legal name": true,
    "Business name": true,
    "Business Address": true,
    "Operating name": true
}

function BLTReview(props) {
    const { bltReview, dispatch } = props
    // const { forChangeRequest } = props.location.state ?? false
    const { queueItem, reviewDataCollectionDebt, sectionsOrder, userData } = bltReview
    const isRenewalApplication = isRenewalTypeApplication(queueItem)

    let { qItemId } = useParams();
    const appData = applicationData(queueItem)
    let decision = ""
    //let internalNotes = ""

    if (queueItem) {
        if (isApplicationProcessed(queueItem)) {
            decision = queueItem.applicationStatus
        } else if (isApplicationProcessingInProgress(queueItem)) {
            decision = queueItem.applicationStatus
        } else {
            // this is first time application opened. check the status to be doubly sure
            if (queueItem.applicationStatus === CONST.APPLICATION_STATUS_UNREAD) {

                // below will only change the local store. data will be eventually 
                // store on server by one or other way.
                if (isAgencyTypeApplication(queueItem)) {
                    if (isBranchApplication(queueItem)) {
                        dispatch(setCurrentBranchApplicationStatus(CONST.APPLICATION_STATUS_OPENED))
                    } else {
                        dispatch(setAgencyApplicationStatus(CONST.APPLICATION_STATUS_OPENED))
                    }
                }
                else if (isIndividualTypeApplication(queueItem))
                    dispatch(setCurrentAgentApplicationStatus(CONST.APPLICATION_STATUS_OPENED))
            }
        }
    } else {
        console.log("queueItem not found");
    }

    // if(appData && appData.internalNotes) 
    //     internalNotes = appData.internalNotes

    const internalNotes = useMemo(() => appData?.internalNoteList?.length > 0 ? appData.internalNoteList : [], [appData?.internalNoteList])

    const lastInformationNote = useMemo(() => {
        const allNotes = appData?.internalNoteList?.length > 0 ? appData.internalNoteList : []
        const infoNotes = allNotes?.filter(note => note.internalNoteCategory === "InformationMap")
        return infoNotes?.length ? infoNotes[infoNotes.length - 1] : null
    }, [appData?.internalNoteList])


    const [applicationDecision, setApplicationDecision] = useState(decision)

    const [showValidationError, setShowValidationError] = useState(false)
    const [validationError, setValidationError] = useState("")
    const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null)
    const [internalNotesText, setInternalNotesText] = useState(lastInformationNote?.note ?? "")
    const [internalNotesSubmitted, setInternalNotesSubmitted] = useState(false)

    const [suretyBondReceivedDate, setSuretyBondReceivedDate] = useState(0)
    const [suretyBondValidationError, setSuretyBondValidationError] = useState(false)
    const [applicationSaveError, setApplicationSaveError] = useState(false)
    const [showLicenceWithdrawView, setShowLicenceWithdrawView] = useState(false);
    const [showUpgradeWithdrawView, setShowUpgradeWithdrawView] = useState(false);
    const [showAgentApplicationApprovalView, setShowAgentApplicationApprovalView] = useState(false);

    const [newAgentEmailAddress, setNewAgentEmailAddress] = useState();
    const [showModalDialog, setShowModalDialog] = useState(false)
    const [emailMessageText, setEmailMessageText] = useState("");
    const [messageRequestStatus, setMessageRequestStatus] = useState(CONST.REQUEST_STATUS.IDLE)
    const [errorString, setErrorString] = useState("")

    const isReadOnly = useMemo(() => {
        let isReadOnly = false

        if (queueItem?.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED
            || queueItem?.applicationStatus === CONST.APPLICATION_STATUS_DENIED
            // || queueItem?.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT // Need to review cancel by client
            || queueItem?.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED) {
            isReadOnly = true
        }
        else if (queueItem
            && queueItem.locked
            && (queueItem.locked
                !== (userData?.email))) {
            isReadOnly = (queueItem.applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW ||
                queueItem.applicationStatus === CONST.APPLICATION_STATUS_PENDING)
        }
        return isReadOnly
    }, [queueItem, userData])

    const cleanup = useCallback(() => {
        setSuretyBondReceivedDate(0)
        setInternalNotesText("")
        setDocumentViewerDocument(null)
        setApplicationDecision("")
    }, [
        setInternalNotesText,
        setApplicationDecision,
        setSuretyBondReceivedDate,
        setDocumentViewerDocument,
    ])

    useEffect(() => {
        if (!queueItem) {
            dispatch(getApplicationById(parseInt(qItemId)));
            return;
        }

        let decision = "";

        if (
            queueItem &&
            (queueItem.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED ||
                queueItem.applicationStatus === CONST.APPLICATION_STATUS_DENIED ||
                queueItem.applicationStatus === CONST.APPLICATION_STATUS_PENDING ||
                queueItem.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED
                // queueItem.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT
                //  WITHDRAWN_BY_CLIENT - Needed to review and set WITHDRAWN_APPROVE
            )
        ) {
            decision = queueItem.applicationStatus;
        }

        setApplicationDecision(decision);
        setInternalNotesText(lastInformationNote?.note);

        const applicationType = applicationTypeFromLicenceSubType(queueItem.licencingSubType);
        const localHost = `${window.location.protocol}//${window.location.host}/#/`;
        const mainAgentNewApplicationLink = `${localHost}${applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
            ? "principal-broker"
            : "compliance-officer"
            }/privacy-notice`;
        const newAgentEmailMessage = `This is the link to create a new ${applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
            ? "Principal Broker"
            : "Compliance Officer"
            } Application. This process will require you to create an account on the sign in screen. 
            <br/> <a href=${mainAgentNewApplicationLink}>${mainAgentNewApplicationLink}</a>`;
        setEmailMessageText(newAgentEmailMessage);
        return () => {
            cleanup();
        };
    }, [
        dispatch,
        queueItem,
        qItemId,
        lastInformationNote,
        setInternalNotesText,
        setApplicationDecision,
        setEmailMessageText,
        cleanup
    ])

    useEffect(() => {
        if (reviewDataCollectionDebt
            && (reviewDataCollectionDebt['suretyBondDataMap'] ||
                reviewDataCollectionDebt['brokerRegulatoryInformationMap'])) {
            const suretyBondItems = reviewDataCollectionDebt['suretyBondDataMap'] ?? reviewDataCollectionDebt['brokerRegulatoryInformationMap']

            if (Array.isArray(suretyBondItems) && (suretyBondItems.length === 2 || suretyBondItems.length === 3)) {
                const dateRelatedObject = suretyBondItems[1]

                Object.keys(dateRelatedObject).forEach(k => {
                    if (k !== 'review') {
                        const date = dateRelatedObject[k]

                        if (date) {
                            setSuretyBondReceivedDate(date)
                        }
                    }
                })
            }
        }

        return () => {
            //Not sure why it was enabled, this was causing setSuretyBondReceivedDate received date to be empty after save.
            // So disabeld
            // setSuretyBondReceivedDate(0)
        }
    }, [reviewDataCollectionDebt, setSuretyBondReceivedDate])




    const afterRequestSuccess = (applicationItem) => {
        let targetStatusForIndividualApplications = applicationDecision

        if (isRenewalApplication) {
            if (isMortgageTypeApplication(applicationTypeFromLicenceSubType(applicationItem.licencingSubType))) {
                if (isAgencyTypeApplication(applicationItem)) {
                    dispatch(handleMortgageBrokerageRenewalReview(applicationItem))
                        .then(moveToNextScreen)
                        .catch(console.error)
                } else if (applicationItem.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION) {
                    dispatch(handleMortgagePrincipalBrokerRenewalReview(applicationItem))
                        .then(moveToNextScreen)
                        .catch(console.error)
                } else {
                    moveToNextScreen()
                }
            } else {
                if (applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED
                    || applicationDecision === CONST.APPLICATION_STATUS_PENDING) {
                    dispatch(handlePostAgencyReviewProcess(applicationItem))
                        .then(() => {
                            moveToNextScreen()
                        })
                        .catch(err => console.log(err))
                } else {
                    // MRA-1249
                    // DENIED, CANCELLED, CANCELLED_BY_CLIENT
                    // All the additional applications are synced with the application status

                    dispatch(sendBranchAndCollectorApplicationStatus(targetStatusForIndividualApplications, targetStatusForIndividualApplications))
                        .then(() => {
                            moveToNextScreen()
                        })                   
                }
            }
        } else {
            if (applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                targetStatusForIndividualApplications = CONST.APPLICATION_STATUS_UNREAD
            } else if (applicationDecision === CONST.APPLICATION_STATUS_PENDING) {
                targetStatusForIndividualApplications = CONST.APPLICATION_STATUS_PENDING_AGENCY
            }

            if (queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
                || queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION) {
                if (!isBranchApplication(queueItem)) {
                    dispatch(sendBranchAndCollectorApplicationStatus(
                        applicationDecision, targetStatusForIndividualApplications)
                    ).then(() => {
                        moveToNextScreen()
                    })
                } else {
                    dispatch(fetchApplicationWithId(queueItem.businessApplicationId))
                        .then(primaryApplication => {
                            if (primaryApplication) {
                                dispatch(setAgencyApplication(primaryApplication))
                            }
                            moveToNextScreen()
                        })
                }
            } else if (queueItem.licencingSubType ===
                CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION) {
                // 1. fetch the principal broker application
                // 2. check if its in approved state.
                // 3. if so, fetch all associated applications other than principal broker
                // 4. set all the applications fetched above to "UNREAD" state.
                dispatch(fetchPrincipalBrokerWithBusinessApplicationId(queueItem.id))
                    .then(principalBrokerApplication => {
                        if (principalBrokerApplication.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                            dispatch(sendBrokerApplicationStatus(targetStatusForIndividualApplications, queueItem.id))
                                .then(() => {
                                    moveToNextScreen()
                                })
                        } else {
                            moveToNextScreen()
                        }
                    })
            } else if (isIndividualTypeApplication(queueItem)) {
                // fetch the primary application before moving to the next screen
                dispatch(fetchApplicationWithId(queueItem.businessApplicationId))
                    .then(primaryApplication => {

                        if (!primaryApplication) {
                            console.error("something went wrong in fetching primary application datas")
                            moveToNextScreen()
                        }

                        dispatch(setAgencyApplication(primaryApplication))

                        const promisesBeforeMoving = []

                        // add the companyRjscDetails in the collector application
                        // if its not present already. The RJSC details are needed 
                        // to fill the licence PDF of individual type applications
                        if (!appData.companyRjscDetails
                            && primaryApplication.businessLicenceData?.companyRjscDetails) {

                            dispatch(setCurrentCollectorCompanyRjscDetails(primaryApplication.businessLicenceData.companyRjscDetails))

                            if (primaryApplication.businessLicenceData.companyTrademark) {
                                dispatch(setCurrentCollectorCompanyTrademark(primaryApplication.businessLicenceData.companyTrademark))
                            }
                            const appType = applicationTypeFromLicenceSubType(queueItem.licencingSubType)

                            const p1 = dispatch(saveBusinessLicenceApplicationData(appType))
                            promisesBeforeMoving.push(p1)
                        }

                        // In case principal broker is approved and primary application is already approved, 
                        // then mark the other associated applications to UNREAD status so that admin can
                        // review & approve them.
                        if (queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
                            && primaryApplication.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {

                            // fetch all associated applications other than principal broker
                            // set all the applications fetched to the target status.
                            const p2 = dispatch(sendBrokerApplicationStatus(
                                targetStatusForIndividualApplications, queueItem.businessApplicationId))
                            promisesBeforeMoving.push(p2)
                        }

                        if (promisesBeforeMoving.length) {
                            Promise.all(promisesBeforeMoving)
                                .then((res) => {
                                    moveToNextScreen()
                                })
                                .catch(err => {
                                    console.error(err)
                                    moveToNextScreen()
                                })
                        } else {
                            moveToNextScreen()
                        }

                    })
                    .catch(err => console.log(err))
            } else {
                moveToNextScreen()
            }
        }
    }

    const approveAndCancelApplication = (cancellableApplication) => {
        if (!cancellableApplication) {
            return;
        }

        if (isIndividualTypeApplication(queueItem)) {
            dispatch(setCurrentAgentApplicationStatus(applicationDecision))
            dispatch(setCurrentAgentLicenceStatus(CONST.LICENCE_STATUS_ACTIVE))
            dispatch(setCurrentAgentApplicationLocked(null))
        }
        const targetApp = {
            ...queueItem,
            changeType: "SAVE",
            applicationStatus: applicationDecision,
            licenceStatus: CONST.LICENCE_STATUS_ACTIVE,
            endDate: cancellableApplication.endDate, //Need the same end date in the transferred app
            locked: null
        };

        dispatch(approveAndCancelApplicationData(targetApp, cancellableApplication))
            .then(applicationItem => {

                dispatch(markDeleteApplications([cancellableApplication])).then((resp) => {
                    afterRequestSuccess(applicationItem);
                }).catch(() => {
                    // Empty response is being return from delete api
                    afterRequestSuccess(applicationItem);
                })
            })
            .catch(error => {
                setApplicationSaveError(true)
                console.error(error)
            })
    }

    const SubSeparator = () => {
        return (
            <hr
                className="bottomMarginNormal"
                style={{ borderColor: "#777", borderWidth: '1px' }}
            />
        )
    }

    const suretyBondDateComponents = useCallback(() => {
        let day = "", month = "", year = ""

        if (parseInt(suretyBondReceivedDate) > 0) {
            const dateObj = new Date(parseInt(suretyBondReceivedDate));
            day = (dateObj.getDate());
            month = (dateObj.getMonth() + 1);
            year = (dateObj.getFullYear());
        }

        return {
            day,
            month,
            year
        }
    }, [suretyBondReceivedDate])


    const onReviewStatusChange = (key, updatedItem, reviewItemIndex, preventSavingApplication) => {
        switch (queueItem.licencingSubType) {
            case CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL:
            case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL:
                if (isBranchApplication(queueItem)) {
                    dispatch(updateBLTBranchApplicationReviewItem({
                        key,
                        item: updatedItem,
                        reviewItemIndex,
                        isRenewalApplication
                    }))
                } else {
                    dispatch(updateBLTAgencyApplicationReviewItem({
                        key,
                        item: updatedItem,
                        reviewItemIndex,
                        isRenewalApplication
                    }))
                }

                if (!preventSavingApplication) {
                    dispatch(saveBusinessLicenceApplicationData(
                        CONST.APPLICATION_TYPE_COLLECTION_AGENCY, CONST.APPLICATION_MODE_NEW, isBranchApplication(queueItem)))
                }

                break
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION:
                dispatch(updateBLTAgencyApplicationReviewItem({
                    key,
                    item: updatedItem,
                    reviewItemIndex,
                    isRenewalApplication
                }))

                if (!preventSavingApplication) {
                    dispatch(saveBusinessLicenceApplicationData(
                        CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, CONST.APPLICATION_MODE_NEW))
                }
                break
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION:
                dispatch(updateBLTAgencyApplicationReviewItem({
                    key,
                    item: updatedItem,
                    reviewItemIndex,
                    isRenewalApplication
                }))

                if (!preventSavingApplication) {
                    dispatch(saveBusinessLicenceApplicationData(
                        CONST.APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, CONST.APPLICATION_MODE_NEW))
                }
                break
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION:
                dispatch(updateBLTAgencyApplicationReviewItem({
                    key,
                    item: updatedItem,
                    reviewItemIndex,
                    isRenewalApplication
                }))

                if (!preventSavingApplication) {
                    dispatch(saveBusinessLicenceApplicationData(
                        CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE, CONST.APPLICATION_MODE_NEW))
                }
                break
            case CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL:
                dispatch(updateBLTAgentApplicationReviewItem({
                    key,
                    item: updatedItem,
                    reviewItemIndex
                }))

                if (!preventSavingApplication) {
                    dispatch(saveBusinessLicenceApplicationData(
                        CONST.APPLICATION_TYPE_COLLECTOR, CONST.APPLICATION_MODE_NEW))
                }
                break
            case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL:
                dispatch(updateBLTAgentApplicationReviewItem({
                    key,
                    item: updatedItem,
                    reviewItemIndex
                }))
                if (!preventSavingApplication) {
                    dispatch(saveBusinessLicenceApplicationData(
                        CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT, CONST.APPLICATION_MODE_NEW))
                }
                break
            case CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION:
            case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION:
                dispatch(updateBLTAgentApplicationReviewItem({
                    key,
                    item: updatedItem,
                    reviewItemIndex,
                    isRenewalApplication
                }))

                if (!preventSavingApplication) {
                    dispatch(saveBusinessLicenceApplicationData(
                        applicationTypeFromLicenceSubType(queueItem.licencingSubType),
                        CONST.APPLICATION_MODE_NEW))
                }
                break
            default:
            // console.log(updatedItem)
        }
    }

    const sectionTitle = (sectionKey) => {
        let title = ""

        switch (sectionKey) {
            case "applicantInformationMap":
                title = "Applicant Information"
                break
            case "criminalHistoryMap":
                title = "Criminal History"
                break
            case "licenceSuspensionDataMap":
                title = "Licence suspensions"
                break
            case "workHistoryMap":
                title = "Work history"
                break
            case "additionalBranchesMap":
                if (isBranchApplication(queueItem)) {
                    title = "Branch Information"
                } else {
                    title = "Branches"
                }
                break
            case "companyTypeInformationMap":
                title = "Company type"
                break
            case "brokerQualificationInformationMap":
                title = "Qualifications"
                break
            case "documentsDataMap":
                if (isRenewalApplication) {
                    title = "Application attachments"
                } else {
                    title = "Documents"
                }
                break
            case "suretyBondDataMap":
                title = "Surety bond"
                break
            case "decisionMap":
                title = "Decision"
                break
            case "internalNotesMap":
                title = "Internal Notes"
                break
            case "principalBrokerInformationMap":
                if (queueItem.licencingSubType ===
                    CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION ||
                    queueItem.licencingSubType ===
                    CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION ||
                    queueItem.licencingSubType ===
                    CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION ||
                    queueItem.licencingSubType ===
                    CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION)
                    title = "Compliance officer"
                else
                    title = "Principal broker"
                break
            case "trustAccountInformationMap":
                title = "Trust account"
                break
            case "fiscalYearInformationMap":
                title = "Fiscal year end date"
                break
            case "criminalRecordsCheckInformationMap":
                title = "Criminal records check"
                break
            case "insuranceInformationMap":
                title = "Errors and Omissions Insurance"
                break
            case 'confirmationInformationMap':
                title = "Confirmation"
                break
            case 'financialRecordsInformationMap':
                title = "Financial records location"
                break
            case 'financialStatementsInformationMap':
                title = "Financial statements"
                break
            case 'appointedAgentInformationMap':
                title = "Appointed agent"
                break
            case "serviceAddressInformationMap":
                title = "Service address"
                break
            case "brokerLicenceHistoryMap":
            case "brokerLicenceHistoryMapTemp":
                title = "Current mortgage broker licences"
                break
            case 'brokerEducationRequirementMap':
            case 'brokerEducationRequirementMapTemp':
                title = "Education requirement"
                break
            case 'brokerCriminalRecordCheckMap':
                title = "Criminal record check"
                break
            case 'brokerRegulatoryInformationMap':
                title = "Completed regulatory information program"
                break
            case 'brokerConfirmationInformationMap':
            case 'brokerRenewalConfirmationInformationMap':
                title = "Confirmation"
                break
            case 'complianceOfficerInformationMap':
                title = "Compliance officer"
                break
            case 'renewedAgentsApplicationsMap':
                if (queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL)
                    title = "Renewed Collectors"
                else if (queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL)
                    title = "Renewed Debt Management agents"
                else
                    title = "Renewed individual applications"
                break
            case 'airInformationMap':
                title = "AIR"
                break;
            case 'changeRequestDetailsMap':
                title = "Change Request Details"
                break;
            case 'changeRequestNewAgentEmailMap':
                title = "New Email"
                break;
            case 'updatedDocumentsMap':
                title = "Uploaded Documents"
                break;

            // case 'cancelLicenceInformationMap':
            //     title = "Cancel Licence Information"
            //     break;

            default:
                title = sectionKey
                break
        }

        return title
    }

    const sectionCompletenessClass = (sectionKey, section = reviewDataCollectionDebt) => {

        if (sectionKey === "internalNotesMap") {
            if (lastInformationNote?.note || internalNotesSubmitted) {
                return "complete"
            }

            return ""
        }

        const reviewSection = section[sectionKey]

        let completedItems = 0;
        let incompleteItems = 0;

        reviewSection?.forEach((item) => {
            if (item.review === "complete") {
                completedItems++
            } else if (item.review === "incomplete") {
                incompleteItems++
            }
        })

        if (incompleteItems > 0) {
            return "incomplete"
        } else if (reviewSection && completedItems === reviewSection.length) {
            return "complete"
        }

        return ""
    }

    /*
     * Rules : 
     * 1. If decision is "approve", then all section must be in "complete"
     * 2. If decision is "pending" or "denied", then all section need not be complete, 
     *    but all should be either complete or incomplete
     * 3. If decision is "withdrawn by client", then no such rules applies   
     */
    const validateCompleteness = () => {

        if (0 && window.location.hostname === "localhost") {
            return true
        }

        const sections = sectionsOrder

        if(!applicationDecision) {
            //For WITHDRAWN_BY_CLIENT review, applicationDecision is not set until its selected in decision map
            // Without review sectionComplete is also empty
            return false;
        }

        for (let i = 0; i < sections.length; i++) {

            const section = sections[i];

            if (section === "internalNotesMap") {
                continue
            }

            const sectionComplete = sectionCompletenessClass(section)

            switch (applicationDecision) {
                case CONST.APPLICATION_STATUS_APPROVED_ISSUED:
                    if (sectionComplete === "incomplete") {
                        setValidationError(ERROR_STRING.BLT_REVIEW_SECTION_NOT_ALL_COMPLETE)
                        return false;
                    } else if (sectionComplete === "") {
                        setValidationError(ERROR_STRING.BLT_REVIEW_SECTION_INCOMPLETE)
                        return false;
                    }
                    break
                case CONST.APPLICATION_STATUS_DENIED:
                case CONST.APPLICATION_STATUS_PENDING:
                    if (sectionComplete === "") {
                        setValidationError(ERROR_STRING.BLT_REVIEW_SECTION_INCOMPLETE)
                        return false;
                    }
                    break;
                case CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED:
                if (sectionComplete === "incomplete") {
                    setValidationError(ERROR_STRING.BLT_REVIEW_SECTION_NOT_ALL_COMPLETE)
                    return false;
                } else if (sectionComplete === "") {
                    setValidationError(ERROR_STRING.BLT_REVIEW_SECTION_INCOMPLETE)
                    return false;
                }
                break;

                case CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT:
                default:
                    // no rule applies
                    break
            }

        }

        return true
    }

    const moveToNextScreen = () => {
        let nextUrl = CONST.ROUTE_PATH.BLT_DECISION_SUMMARY
        dispatch(push(nextUrl.replace(':status', applicationDecision.toLowerCase())))
    }

    const handleContinue = () => {

        let applicationType = applicationTypeFromLicenceSubType(queueItem.licencingSubType)

        const isActiveLicenceStatus = queueItem.licenceStatus === CONST.LICENCE_STATUS_ACTIVE

        if (isAgencyTypeApplication(queueItem)) {
            if (applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT ||
                applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED) {
                /* If "Cancelled by client" selected from adjudication screen then It goes to APPLICATION_STATUS_WITHDRAWN_APPROVED
                instead of APPLICATION_STATUS_WITHDRAWN_BY_CLIENT (To avoid confirm button in pending queue list) */
                if (isBranchApplication(queueItem)) {
                    dispatch(setCurrentBranchApplicationStatus(CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED))
                    dispatch(setCurrentBranchApplicationLicenceStatus(CONST.LICENCE_STATUS_WITHDRAWN_BY_CLIENT))
                } else {
                    dispatch(setAgencyApplicationStatus(CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED))
                    dispatch(setAgencyApplicationLicenceStatus(CONST.LICENCE_STATUS_WITHDRAWN_BY_CLIENT))
                }
            }
            else {
                if (isBranchApplication(queueItem)) {
                    dispatch(setCurrentBranchApplicationStatus(applicationDecision))
                } else {
                    dispatch(setAgencyApplicationStatus(applicationDecision))

                    //Reset the value used for File upload
                    dispatch(setMortgageProperty({key: "isDocumentUpdated", value: false}))

                    if (isChangeRequestTypeApplication(queueItem)) {
                        if (applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                            dispatch(setCurrentMainAgentChangeRequestForApproval({ approverEmail: userData?.email }));
                        }
                    }
                }
            }

            if (isBranchApplication(queueItem)) {
                dispatch(setCurrentBranchApplicationLocked(null))
            } else {
                dispatch(setAgencyApplicationLocked(null))
            }

            if (applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                if (isBranchApplication(queueItem)) {
                    dispatch(setCurrentBranchApplicationLicenceStatus(CONST.LICENCE_STATUS_ACTIVE))
                } else {
                    dispatch(setAgencyApplicationLicenceStatus(CONST.LICENCE_STATUS_ACTIVE))
                }
            }
            if(!isBranchApplication(queueItem)) {
                dispatch(setAgencyDocumentsIsUpdatedReset());
            }
                        
        } else if (isIndividualTypeApplication(queueItem)) {
            if (applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT || applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED) {
                dispatch(setCurrentAgentApplicationStatus(CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED))
                dispatch(setCurrentAgentLicenceStatus(CONST.LICENCE_STATUS_WITHDRAWN_BY_CLIENT))
                dispatch(setCurrentAgentLicenceExpiryDate(Date.now()))
            }
            else {
                //Reset (If any) - value used for File upload
                dispatch(
                    setCurrentAgentMortgageProperty({
                        key: "isDocumentUpdated",
                        value: false
                    })
                );
                dispatch(setCurrentAgentApplicationStatus(applicationDecision))
            }

            dispatch(setCurrentAgentDocumentsIsUpdatedReset())
            dispatch(setCurrentAgentApplicationLocked(null))

            if (applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                dispatch(setCurrentAgentLicenceStatus(CONST.LICENCE_STATUS_ACTIVE))
            }

            // primaryBusinessApplicationId = queueItem.businessApplicationId
        }

        dispatch(saveBusinessLicenceApplicationData(applicationType, CONST.APPLICATION_MODE_NEW, isBranchApplication(queueItem)))
            .then(applicationItem => {
                if(isActiveLicenceStatus) { //For updated docuemnt review on active apps
                    goBackToQueue()
                }
                else {
                    afterRequestSuccess(applicationItem);
                }
            })
            .catch(error => {
                setApplicationSaveError(true)
                console.error(error)
            })
    }

    const decisionSectionComponent = (sectionKey, item) => {

        const handleApplicationStatusChange = (e) => {
            setApplicationDecision(e.target.value)
            onReviewStatusChange(sectionKey, {
                ...item,
                ...{ review: "complete" }
            })
        }

        const onClickContinue = () => {
            if (!validateCompleteness()) {
                setShowValidationError(true)
                return
            }
            setShowValidationError(false)

            if(queueItem.licenceStatus !== CONST.LICENCE_STATUS_ACTIVE) {
                 if (queueItem.businessLicenceData.licenceUpgradeApplicationId && applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                setShowUpgradeWithdrawView(true)
                }
                //brokerLicenceNumber
                else if (queueItem.businessLicenceData?.currentlyBrokerInNS && applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                    //For AMB to MB upgrade
                    setShowLicenceWithdrawView(true)
                }
                else if (isMortgageMainAgentTypeApplication(applicationTypeFromLicenceSubType(queueItem.licencingSubType)) &&
                    queueItem.businessLicenceData?.mraNSLicenceNumber &&
                    applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                    //This is for transfer of AMB or MB
                    setShowLicenceWithdrawView(true)
                }
                else if (isIndividaulPrincipalBrokerApplication(applicationTypeFromLicenceSubType(queueItem.licencingSubType)) &&
                    applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                    //For MB to principal broker within organisation
                    //Individual application 
                    setShowAgentApplicationApprovalView(true)
                }
                else {
                    handleContinue()
                }
            }
            else {
                 handleContinue()
            }
           
        }

        return (
            <div className="decisionFormItem">
                <div className="decisionFormItemInfo bottomMarginNormal">
                    Based on the information in this application, select a new application status
                </div>
                <div className="bltreview-decision-form">
                    <fieldset className="ns-fieldset">
                        {queueItem.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT ? (
                            <div className={"ns-radios ns-radios--small"}>
                                <div key={"withdrawn-approved-decision"} className="ns-radios__item">
                                    <input
                                        className="ns-radios__input"
                                        key={"withdrawn-approved-decision-input"}
                                        type={"radio"}
                                        value={CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED}
                                        checked={
                                            applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED
                                        }
                                        onChange={handleApplicationStatusChange}
                                        id={"bltreview-decision-form-withdrawn-approved-input"}
                                        name={"bltreview-decision-form-withdrawn-approved-input"}
                                        disabled={isReadOnly}
                                    />
                                    <label
                                        key={"withdrawn-approved-decision-label"}
                                        id={"bltreview-decision-form-withdrawn-approved--label"}
                                        className="ns-radios__label"
                                        htmlFor={"bltreview-decision-form-withdrawn-approved-input"}
                                    >
                                        <div className="licence-status-withdrawn">
                                            <i className="fa fa-exclamation-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Cancelled</span>
                                        <span className="bltReviewDecisionInfo">
                                            Approve the requested license cancellation.
                                        </span>
                                    </label>
                                </div>
                            </div>
                        ) : (queueItem.licenceStatus === CONST.LICENCE_STATUS_ACTIVE &&
                            isHavingUpdatedDocuments(queueItem) ? (
                            <div className={"ns-radios ns-radios--small"}>
                                <div key={"approve-decision"} className="ns-radios__item">
                                    <input
                                        className="ns-radios__input"
                                        key={"approve-decision-input"}
                                        type={"radio"}
                                        value={CONST.APPLICATION_STATUS_APPROVED_ISSUED}
                                        checked={applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED}
                                        onChange={handleApplicationStatusChange}
                                        id={"bltreview-decision-form-approve-input"}
                                        name={"bltreview-decision-form-approve-input"}
                                        disabled={isReadOnly}
                                    />
                                    <label
                                        key={"approve-decision-label"}
                                        id={"bltreview-decision-form-approve-label"}
                                        className="ns-radios__label"
                                        htmlFor={"bltreview-decision-form-approve-input"}
                                    >
                                        <div className="licence-status-approved">
                                            <i className="fa fa-check-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Approved</span>
                                        <span className="bltReviewDecisionInfo">Documents are appropriate</span>
                                    </label>
                                </div>
                                <div key={"pending-decision"} className="ns-radios__item">
                                    <input
                                        className="ns-radios__input"
                                        key={"pending-decision-input"}
                                        type={"radio"}
                                        value={CONST.APPLICATION_STATUS_PENDING}
                                        checked={applicationDecision === CONST.APPLICATION_STATUS_PENDING}
                                        onChange={handleApplicationStatusChange}
                                        id={"bltreview-decision-form-pending-input"}
                                        name={"bltreview-decision-form-pending-input"}
                                        disabled={isReadOnly}
                                    />
                                    <label
                                        key={"pending-decision-label"}
                                        id={"bltreview-decision-form-pending--label"}
                                        className="ns-radios__label"
                                        htmlFor={"bltreview-decision-form-pending-input"}
                                    >
                                        <div className="licence-status-pending">
                                            <i className="fa fa-clock-o fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Pending</span>
                                        <span className="bltReviewDecisionInfo">
                                            Documents are inappropriate and client needs to provide the same
                                        </span>
                                    </label>
                                </div>
                            </div>
                        ) : (
                            <div className={"ns-radios ns-radios--small"}>
                                <div key={"approve-decision"} className="ns-radios__item">
                                    <input
                                        className="ns-radios__input"
                                        key={"approve-decision-input"}
                                        type={"radio"}
                                        value={CONST.APPLICATION_STATUS_APPROVED_ISSUED}
                                        checked={applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED}
                                        onChange={handleApplicationStatusChange}
                                        id={"bltreview-decision-form-approve-input"}
                                        name={"bltreview-decision-form-approve-input"}
                                        disabled={isReadOnly}
                                    />
                                    <label
                                        key={"approve-decision-label"}
                                        id={"bltreview-decision-form-approve-label"}
                                        className="ns-radios__label"
                                        htmlFor={"bltreview-decision-form-approve-input"}
                                    >
                                        <div className="licence-status-approved">
                                            <i className="fa fa-check-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Approved</span>
                                        <span className="bltReviewDecisionInfo">
                                            Application is complete and client is eligible for licensing
                                        </span>
                                    </label>
                                </div>
                                <div key={"pending-decision"} className="ns-radios__item">
                                    <input
                                        className="ns-radios__input"
                                        key={"pending-decision-input"}
                                        type={"radio"}
                                        value={CONST.APPLICATION_STATUS_PENDING}
                                        checked={applicationDecision === CONST.APPLICATION_STATUS_PENDING}
                                        onChange={handleApplicationStatusChange}
                                        id={"bltreview-decision-form-pending-input"}
                                        name={"bltreview-decision-form-pending-input"}
                                        disabled={isReadOnly}
                                    />
                                    <label
                                        key={"pending-decision-label"}
                                        id={"bltreview-decision-form-pending--label"}
                                        className="ns-radios__label"
                                        htmlFor={"bltreview-decision-form-pending-input"}
                                    >
                                        <div className="licence-status-pending">
                                            <i className="fa fa-clock-o fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Pending</span>
                                        <span className="bltReviewDecisionInfo">
                                            Application is incomplete and client needs to provide additional details
                                            before they're eligible for licensing
                                        </span>
                                    </label>
                                </div>
                                <div key={"deny-decision"} className="ns-radios__item">
                                    <input
                                        className="ns-radios__input"
                                        key={"deny-decision-input"}
                                        type={"radio"}
                                        value={CONST.APPLICATION_STATUS_DENIED}
                                        checked={applicationDecision === CONST.APPLICATION_STATUS_DENIED}
                                        onChange={handleApplicationStatusChange}
                                        id={"bltreview-decision-form-denied-input"}
                                        name={"bltreview-decision-form-denied-input"}
                                        disabled={isReadOnly}
                                    />
                                    <label
                                        key={"deny-decision-label"}
                                        id={"bltreview-decision-form-denied--label"}
                                        className="ns-radios__label"
                                        htmlFor={"bltreview-decision-form-denied-input"}
                                    >
                                        <div className="licence-status-denied">
                                            <i className="fa fa-times-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Denied</span>
                                        <span className="bltReviewDecisionInfo">
                                            Application doesn't meet requirements and client is ineligible for
                                            licensing
                                        </span>
                                    </label>
                                </div>
                                <div key={"withdrawn-decision"} className="ns-radios__item">
                                    <input
                                        className="ns-radios__input"
                                        key={"withdrawn-decision-input"}
                                        type={"radio"}
                                        value={CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT}
                                        checked={
                                            applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT
                                        }
                                        onChange={handleApplicationStatusChange}
                                        id={"bltreview-decision-form-withdrawn-input"}
                                        name={"bltreview-decision-form-withdrawn-input"}
                                        disabled={isReadOnly}
                                    />
                                    <label
                                        key={"withdrawn-decision-label"}
                                        id={"bltreview-decision-form-withdrawn--label"}
                                        className="ns-radios__label"
                                        htmlFor={"bltreview-decision-form-withdrawn-input"}
                                    >
                                        <div className="licence-status-withdrawn">
                                            <i className="fa fa-exclamation-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">
                                            Cancelled by client
                                        </span>
                                        <span className="bltReviewDecisionInfo">
                                            Client no longer wants to proceed with application.
                                        </span>
                                    </label>
                                </div>
                                <div key={"withdrawn-approved-decision"} className="ns-radios__item">
                                    <input
                                        className="ns-radios__input"
                                        key={"withdrawn-approved-decision-input"}
                                        type={"radio"}
                                        value={CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED}
                                        checked={
                                            applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED
                                        }
                                        onChange={handleApplicationStatusChange}
                                        id={"bltreview-decision-form-withdrawn-approved-input"}
                                        name={"bltreview-decision-form-withdrawn-approved-input"}
                                        disabled={isReadOnly}
                                    />
                                    <label
                                        key={"withdrawn-approved-decision-label"}
                                        id={"bltreview-decision-form-withdrawn-approved--label"}
                                        className="ns-radios__label"
                                        htmlFor={"bltreview-decision-form-withdrawn-approved-input"}
                                    >
                                        <div className="licence-status-withdrawn">
                                            <i className="fa fa-exclamation-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Cancelled</span>
                                        <span className="bltReviewDecisionInfo">
                                            Approve the requested license cancellation.
                                        </span>
                                    </label>
                                </div>
                            </div>
                        ))}
                    </fieldset>
                </div>
                {!isReadOnly && (
                    <>
                        <div
                            className={
                                "decisionFormItemButton bottomMarginNormal" +
                                (showValidationError || applicationSaveError ? " has-error" : "")
                            }
                        >
                            <Button
                                id="decision-form-item-button"
                                buttonType="regular_primary"
                                text="Continue"
                                onClick={onClickContinue}
                            />
                            {(showValidationError || applicationSaveError) && ErrorMark()}
                            {(showValidationError || applicationSaveError) && (
                                <div className="help-blocked">
                                    {showValidationError
                                        ? validationError
                                        : applicationSaveError
                                            ? "Could not save application."
                                            : ""}
                                </div>
                            )}
                        </div>
                        {queueItem.licenceStatus !== CONST.LICENCE_STATUS_ACTIVE && (
                            <div className="decisionFormItemInfo bottomMarginNormal">
                                Provide additional information to the client about their licence status in the
                                next step
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    }

    const internalNotesSectionComponents = (sectionKey, item) => {
        return (
            <div className="decisionFormItem" key={`${sectionKey}-${queueItem.id}`}>
                <div className="internalNotesFormItem">
                    <div style={{ color: "#555", fontWeight: "bold", fontSize: "1em" }}>
                        Internal notes won't be shared with the client but will be saved on the client record
                    </div>
                    <div className="textarea fw-35 bottomMarginNormal">
                        <textarea
                            className="ns-input"
                            id={`blt-review-internalnotes-textarea-${queueItem.id}`}
                            key={`${sectionKey}-${queueItem.id}`}
                            rows={5}
                            cols={80}
                            value={internalNotesText ?? ""}
                            maxLength={5000}
                            onInput={(e) => {
                                setInternalNotesText(e.target.value)
                            }}
                        />
                    </div>
                    <div className="bottomMarginNormal">
                        <Button
                            id="blt-review-internalnotes-save-button"
                            buttonType="regular_success"
                            text="Save"
                            onClick={() => {

                                const newNote = { note: internalNotesText, changeType: "SAVE", internalNoteCategory: "InformationMap" };
                                const newNotes = [...internalNotes, newNote];

                                if (isAgencyTypeApplication(queueItem)) {
                                    //dispatch(setInternalNotes(internalNotesText))
                                   
                                    if(isBranchApplication(queueItem)) {
                                        dispatch(setCurrentBranchApplicationInternalNotes(newNotes))
                                    }
                                    else {
                                         dispatch(setInternalNoteList(newNotes))
                                    }
                                }
                                else if (isIndividualTypeApplication(queueItem)) {
                                    // dispatch(setCurrentAgentInternalNotes(internalNotesText))
                                    dispatch(setCurrentAgentInternalNoteList(newNotes))
                                }

                                if (internalNotesText?.length) {
                                    setInternalNotesSubmitted(true);
                                }
                                else {
                                    setInternalNotesSubmitted(false);
                                }

                                onReviewStatusChange(sectionKey, {
                                    ...item,
                                    review: "complete"
                                })
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }

    const documentComponent = (d) => {
        return (
            <>
                {d.documentContentType === CONST.DOCUMENT_CONTENT_TYPE_PDF ?
                        <DocumentViewerFileNameLink
                            id={"blamin-review-file-" + d.filename}
                            key={"blamin-review-file-" + d.filename}
                            file={d}
                            onClick={() => {
                                if (d.data) {
                                    let fileDataUrl = convertFileDataForUrl(d.data, d.documentContentType)
                                    setDocumentViewerDocument(fileDataUrl)
                                    setOpenDocumentViewer(true)
                                    setSelectedFile(d)
                                } else {
                                    // download data and then view it.
                                    if (d.guid) {
                                        dispatch(fetchDocumentData(d.guid))
                                            .then(downloadFile => {
                                                if (downloadFile) {
                                                    let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                    setDocumentViewerDocument(fileDataUrl)
                                                    setOpenDocumentViewer(true)
                                                    setSelectedFile(downloadFile)
                                                }
                                            })
                                            .catch((error) => {
                                                console.error(error)
                                            })
                                    }
                                }
                            }}
                    /> :
                    <DownloadFileNameLink
                        id={"bladmin-review-download-file-" + d.filename}
                        componentKey={"bladmin-review-download-file-" + d.filename}
                        file={d}
                    />}
            </>
        )
    }

    const emptyDocument = () => {
        return (
            <div className='row' style={{ marginLeft: "5px" }}>
                <span>{"NO FILE UPLOADED"}</span>
            </div>
        )
    }

    const documentsSectionComponent = (sectionKey, item) => {
        let formsComponents = []
        let noticesComponents = []
        let formDocuments = [];
        let noticesDocuments = [];


        let formsReview = "", noticesReview = ""

        item.forEach((d) => {
            let component = null

            if ("filename" in d) {
                component = documentComponent(d)
            } else {
                component = emptyDocument()
            }

            if (d.type === CONST.DOCUMENT_TYPE_FORMS_AGREEMENTS) {
                formsComponents.push(component)
                formDocuments.push(d);
                formsReview = d.review
            } else if (d.type === CONST.DOCUMENT_TYPE_NOTICES_LETTERS) {
                noticesReview = d.review
                noticesComponents.push(component)
                noticesDocuments.push(d);
            }
        })

        return (
            <>
                <ReviewForm
                    data={{ "Forms and agreements": formsComponents }}
                    documentData={formDocuments.length ? formDocuments[0] : null}
                    review={formsReview}
                    isReadOnly={isReadOnly}
                    onStatusChange={(updatedItem) => {
                        let reviewedDocs = item.map(d => {
                            if (d.type === CONST.DOCUMENT_TYPE_FORMS_AGREEMENTS) {
                                return {
                                    ...d,
                                    review: updatedItem.review
                                }
                            } else {
                                return d
                            }
                        })

                        onReviewStatusChange(sectionKey, reviewedDocs)
                    }}
                />
                <SubSeparator />
                <ReviewForm
                    data={{ "Notices and letters": noticesComponents }}
                    documentData={noticesDocuments.length ? noticesDocuments[0] : null}
                    review={noticesReview}
                    isReadOnly={isReadOnly}
                    showConfirmation={0 && isRenewalApplication}
                    confirmationMessage={`Is the ${sectionTitle(sectionKey)} section complete and correct?`}
                    onStatusChange={(updatedItem) => {
                        let reviewedDocs = item.map(d => {
                            if (d.type === CONST.DOCUMENT_TYPE_NOTICES_LETTERS) {
                                return {
                                    ...d,
                                    review: updatedItem.review
                                }
                            } else {
                                return d
                            }
                        })
                        onReviewStatusChange(sectionKey, reviewedDocs)
                    }}
                />
            </>
        )
    }

    const criminalRecordsCheckComponent = (sectionKey, reviewItem) => {
        const fileComponents = []

        reviewItem.forEach((doc, index) => {
            let docComponent = null

            if ("filename" in doc) {
                docComponent = documentComponent(doc)
            } else {
                docComponent = emptyDocument()
            }

            const data = {
                "Name:": doc["Name"],
                "Position:": doc["Position"],
                "Updated Criminal Record Check Uploaded": doc["uploadedForRenewal"] ? "Yes" : "No",
                "Uploaded file": docComponent
            };
            if ("filename" in doc) {
                data["Received Date:"] = humanReadableDate(doc.createdDate);
                data["Uploaded by:"] = doc.createdBy;
            }

            fileComponents.push(
                <ReviewForm
                    key={doc.id}
                    data={data}
                    review={doc.review}
                    isReadOnly={isReadOnly}
                    onStatusChange={(updatedItem) => {
                        const reviewedDocs = reviewItem.map((d, id) => {
                            if (index === id)
                                return {
                                    ...doc,
                                    review: updatedItem.review
                                };
                            else {
                                return d;
                            }
                        });
                        onReviewStatusChange(sectionKey, reviewedDocs);
                    }}
                />
            );
            
            if ((reviewItem.length - 1) > index) {
                fileComponents.push(<SubSeparator />);
            }

        })

        return fileComponents
    }

    const insuranceRecordsComponent = (sectionKey, reviewItem) => {
        const fileComponents = []

        if (isRenewalApplication && reviewItem.length > 0) {
            fileComponents.push(
                <ReviewForm
                    key={reviewItem[0].id}
                    data={reviewItem[0]}
                    isReadOnly={isReadOnly}
                    onStatusChange={updatedItem => {

                        let updatedReviewItem = [
                            ...reviewItem
                        ]
                        updatedReviewItem.splice(0, 1, updatedItem)
                        onReviewStatusChange(sectionKey, updatedReviewItem)
                    }}
                />
            )
        }

        reviewItem.forEach((doc, index) => {
            let docComponent = null

            if ("filename" in doc) {
                docComponent = documentComponent(doc)
            } else {
                // Don't show empty document component for renewal flow
                if (!isRenewalApplication)
                    docComponent = emptyDocument()
            }

            if (docComponent) {
                fileComponents.push(
                    <ReviewForm
                        key={index + doc.id}
                        data={{ "Uploaded file": docComponent }}
                        review={doc.review}
                        documentData={doc}
                        isReadOnly={isReadOnly}
                        onStatusChange={(updatedItem) => {
                            const reviewedDocs = reviewItem.map((d, id) => {
                                if (index === id)
                                    return {
                                        ...doc,
                                        review: updatedItem.review
                                    }
                                else
                                    return d
                            })
                            onReviewStatusChange(sectionKey, reviewedDocs)
                        }}
                    />)
            }
        })

        return fileComponents
    }

    const updatedDocumentsComponent = (sectionKey, reviewItem) => {
        const updatedFileComponents = []

        reviewItem.forEach((doc, index) => {
            let docComponent = null
            let docData = null

            if ("filename" in doc) {
                docComponent = documentComponent(doc)
            }

            if (doc.documentType === CONST.DOCUMENT_TYPE_CRIMINAL_RECORD) {
                docData = {
                    "Document Type:": getDocumentTypeName(doc.documentType),
                    "Name:": doc["Name"],
                    "Position:": doc["Position"],
                    "Date:" :  humanReadableDate(doc.createdDate),
                    "Uploaded file": docComponent,
                }
            }
            else {
                docData = {
                    "Document Type:": getDocumentTypeName(doc.documentType),
                    "Date:" :  humanReadableDate(doc.createdDate),
                    "Uploaded file": docComponent,
                }
            }

            if (docComponent) {
                updatedFileComponents.push(
                    <ReviewForm
                        key={index + doc.id}
                        data={docData}
                        documentData={doc}
                        review={doc.review}
                        isReadOnly={isReadOnly}
                        onStatusChange={(updatedItem) => {
                            const reviewedDocs = reviewItem.map((d, id) => {
                                if (index === id)
                                    return {
                                        ...doc,
                                        review: updatedItem.review
                                    }
                                else
                                    return d
                            })
                            onReviewStatusChange(sectionKey, reviewedDocs)
                        }}
                    />)
            }
        })

        return updatedFileComponents
    }

    // const cancelLicenceInformationMap = (sectionKey, reviewItem) => {

    //     return reviewItem?.map((item, reviewItemIndex) => {
    //         return <ReviewForm
    //             key={reviewItemIndex}
    //             data={item}
    //             review={item.review}
    //             isReadOnly={isReadOnly}
    //             onStatusChange={(updatedItem) => onReviewStatusChange(sectionKey, updatedItem, reviewItemIndex)}
    //         />

    //     })

    // }

    const airInformationComponent = (sectionKey, reviewItem) => {
        const fileComponents = []

        if (isRenewalApplication) {
            reviewItem.forEach((review, index) => {
                if ("filename" in review) {
                    const docComponent = documentComponent(review)
                    fileComponents.push(
                        <ReviewForm
                            key={review.id}
                            data={{ "Uploaded file": docComponent }}
                            documentData={review}
                            review={review.review}
                            isReadOnly={isReadOnly}
                            onStatusChange={(updatedItem) => {
                                const reviewedDocs = reviewItem.map((d, id) => {
                                    if (index === id)
                                        return {
                                            ...review,
                                            review: updatedItem.review
                                        }
                                    else
                                        return d
                                })
                                onReviewStatusChange(sectionKey, reviewedDocs)
                            }}
                        />)
                } else {
                    fileComponents.push(
                        <ReviewForm
                            key={review.id}
                            data={review}
                            isReadOnly={isReadOnly}
                            onStatusChange={updatedItem => {

                                const reviewedItem = reviewItem.map((d, id) => {
                                    if (index === id)
                                        return {
                                            ...review,
                                            review: updatedItem.review
                                        }
                                    else
                                        return d
                                })
                                onReviewStatusChange(sectionKey, reviewedItem)
                            }}
                        />
                    )
                }
            })
        } else {
            reviewItem.forEach((doc, index) => {
                let docComponent = null

                if ("filename" in doc) {
                    docComponent = documentComponent(doc)
                } else {
                    // Don't show empty document component for renewal flow
                    if (!isRenewalApplication)
                        docComponent = emptyDocument()
                }

                if (docComponent) {
                    fileComponents.push(
                        <ReviewForm
                            key={doc.id}
                            data={{ "Uploaded file": docComponent }}
                            documentData={doc}
                            review={doc.review}
                            isReadOnly={isReadOnly}
                            onStatusChange={(updatedItem) => {
                                const reviewedDocs = reviewItem.map((d, id) => {
                                    if (index === id)
                                        return {
                                            ...doc,
                                            review: updatedItem.review
                                        }
                                    else
                                        return d
                                })
                                onReviewStatusChange(sectionKey, reviewedDocs)
                            }}
                        />)
                }
            })
        }

        return fileComponents
    }

    const confirmationComponent = (sectionKey, reviewItem, isRenewalApplication) => {

        const components = []
        const name = fullName(appData?.personData ?? appData?.mainBusinessContact)

        const handleConfirmationReviewChange = (index, review) => {
            const reviewedItems = reviewItem.map((item, id) => {
                if (id === index) {
                    return {
                        ...item,
                        review
                    }
                } else {
                    return item
                }
            })

            onReviewStatusChange(sectionKey, reviewedItems)
        }

        if (sectionKey === "confirmationInformationMap") {
            if (queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION
                || queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
                || queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION
                // || queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION
                // || queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION
            ) {

                const mainAgentString = (queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION
                    || queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION
                    || queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION) ? 'Principal Broker' : 'Compliance Officer';

                components.push(
                    <div
                        key={`data-review-declaration-text`}
                        id={`data-review-declaration-text`}
                        className="row bottomMarginNormal bltReviewFormItem"
                    >
                        <div className={"col-lg-10 bottomMarginNormal"}>
                            {`I, ${name}, confirm, that I have read and understand the Mortgage Regulation Act and its regulations and agree to be bound by their provisions.`}
                        </div>
                        <div className={"col-lg-10 bottomMarginNormal"}>
                            {`I, ${name}, confirm, as ${mainAgentString} I am able to carry out the duties and responsibilities of a ${mainAgentString.toLowerCase()} on behalf of the mortgage brokerage.  Some of those duties include:`}
                        </div>
                    </div>
                )
            }
        }

        reviewItem.forEach((item, index) => {
            const componentId = `${sectionKey}-${index}`
            const itemReview = item.review

            components.push(
                <>
                    <div
                        key={`data-review-${componentId}`}
                        id={`data-review-${componentId}`}
                        className="row bottomMarginNormal bltReviewFormItem"
                    >
                        <div className={isRenewalApplication ? "col-lg-8" : "col-lg-10"} dangerouslySetInnerHTML={{ __html: item.duty }}>
                        </div>
                        {isRenewalApplication && <div className={"col-lg-2"}><b>{item.confirmation}</b></div>}
                        <div className="col-lg-2">
                            <button
                                key={`${componentId}-fail`}
                                id={`${componentId}-fail`}
                                className={"bltReviewFormItemCheckMark" + (itemReview === "incomplete" ? " bltReviewFormItemCheckMarkFail" : "")}
                                onClick={() => {
                                    handleConfirmationReviewChange(index, "incomplete")
                                }}
                                disabled={isReadOnly}
                            >
                                <i className="fa fa-2x fa-times-circle"></i>
                            </button>
                            <button
                                key={`${componentId}-pass`}
                                id={`${componentId}-pass`}
                                className={"bltReviewFormItemCheckMark" + (itemReview === "complete" ? " bltReviewFormItemCheckMarkPass" : "")}
                                onClick={() => {
                                    handleConfirmationReviewChange(index, "complete")
                                }}
                                disabled={isReadOnly}
                            >
                                <i className="fa fa-2x fa-check-circle"></i>
                            </button>
                        </div>
                    </div>
                    {(index < reviewItem.length - 1) && <LineSeperator />}
                </>
            )
        })

        return components
    }

    const suretyBondSectionComponent = (sectionKey, reviewItem) => {

        if (!Array.isArray(reviewItem)
            || reviewItem.length !== 2) {
            return null
        }

        const item = reviewItem[0] // 0th item
        const item2 = reviewItem[1] // second item
        const impKeys = Object.keys(item2).filter(k => k !== "review")
        let objKey = null
        if (impKeys?.length > 0) {
            objKey = impKeys[0]
        }

        //const suretyBondReceivedDate = item2[objKey]

        return (
            <>
                <ReviewForm
                    data={item}
                    review={item.review}
                    isReadOnly={isReadOnly}
                    onStatusChange={(updatedItem) => onReviewStatusChange(sectionKey, updatedItem, 0)}
                />
                
                <div className="row topMarginNormal">
                    <div className="col-lg-5">
                        <strong style={{ marginLeft: "10px" }}>
                            {objKey}
                        </strong>
                    </div>
                    <div className="col-lg-7 bltReviewSuretyBondDateReceived">
                        <div className="row" style={{ display: "flex", flexDirection: "column" }}>
                            <DateSelectionComponentsForm
                                id="bltreview-surety-bond-received"
                                dateComponents={suretyBondDateComponents()}
                                disableFutureDate={true}
                                showValidationError={suretyBondValidationError}
                                readOnly={isReadOnly}
                                onDateComponentsChange={({ day, month, year }) => {
                                    // convert into numbers
                                    const d = +day
                                    const m = +month
                                    const y = +year
                                    // some basic validations
                                    let properDate = ((d >= 1 && d <= 31) &&
                                        (m >= 1 && m <= 12) &&
                                        y >= 1900)

                                    if (properDate) {
                                        // conver into date object
                                        const dateObj = new Date(y, m - 1, d);

                                        if (!isNaN(dateObj.getTime())) {
                                            setSuretyBondValidationError(false)
                                            setSuretyBondReceivedDate(dateObj.getTime())
                                        }
                                    }
                                }}
                            />
                            {!isReadOnly && <div className="topMarginNormal rightAlign">
                                <Button
                                    buttonType="regular_success"
                                    text="Save"
                                    onClick={() => {
                                        // validate the date
                                        if (!suretyBondReceivedDate || IsDateInFuture(suretyBondReceivedDate)) {
                                            //
                                            setSuretyBondValidationError(true)
                                            return
                                        }

                                        if (sectionKey === "brokerRegulatoryInformationMap") {
                                            if (isMortgageMainAgentTypeApplication(applicationTypeFromLicenceSubType(queueItem.licencingSubType))) {
                                                dispatch(setConfirmSuretyBond(suretyBondReceivedDate))
                                            } else {
                                                dispatch(
                                                    setCurrentAgentRegulatoryInformationReceivedDate(suretyBondReceivedDate))
                                            }
                                        } else {
                                            dispatch(setConfirmSuretyBond(suretyBondReceivedDate))
                                        }

                                        onReviewStatusChange(
                                            sectionKey,
                                            {
                                                ...item2,
                                                ...Object.defineProperty(
                                                    { "review": "complete" },
                                                    objKey,
                                                    {
                                                        value: suretyBondReceivedDate,
                                                        enumerable: true,
                                                        writable: true
                                                    })
                                            },
                                            1
                                        )
                                    }}
                                />
                            </div>}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const brokerSuretyBondSectionComponent = (sectionKey, reviewItem) => {

        if (!Array.isArray(reviewItem) || reviewItem.length < 2) {
            return null;
        }

        const item = reviewItem[0]; // 1st item
        const item2 = reviewItem[1]; // second item
        let item3 = null;
        if (reviewItem.length === 3) {
            item3 = reviewItem[2]; // third item
        }
        const impKeys = Object.keys(item2).filter((k) => k !== "review");
        let objKey = null;
        if (impKeys?.length > 0) {
            objKey = impKeys[0];
        }

        //const suretyBondReceivedDate = item2[objKey]

        return (
            <>
                <ReviewForm
                    data={item}
                    review={item.review}
                    isReadOnly={isReadOnly}
                    onStatusChange={(updatedItem) => onReviewStatusChange(sectionKey, updatedItem, 0)}
                />

                <div className="row topMarginNormal">
                    <div className="col-lg-5">
                        <strong style={{ marginLeft: "10px" }}>{objKey}</strong>
                    </div>
                    <div className="col-lg-7 bltReviewSuretyBondDateReceived">
                        <div className="row" style={{ display: "flex", flexDirection: "column" }}>
                            <DateSelectionComponentsForm
                                id="bltreview-surety-bond-received"
                                dateComponents={suretyBondDateComponents()}
                                disableFutureDate={true}
                                showValidationError={suretyBondValidationError}
                                readOnly={isReadOnly}
                                onDateComponentsChange={({ day, month, year }) => {
                                    // convert into numbers
                                    const d = +day;
                                    const m = +month;
                                    const y = +year;
                                    // some basic validations
                                    let properDate = d >= 1 && d <= 31 && m >= 1 && m <= 12 && y >= 1900;

                                    if (properDate) {
                                        // conver into date object
                                        const dateObj = new Date(y, m - 1, d);

                                        if (!isNaN(dateObj.getTime())) {
                                            setSuretyBondValidationError(false);
                                            setSuretyBondReceivedDate(dateObj.getTime());
                                        }
                                    }
                                }}
                            />
                            {!isReadOnly && (
                                <div className="topMarginNormal rightAlign">
                                    <Button
                                        buttonType="regular_success"
                                        text="Save"
                                        onClick={() => {
                                            // validate the date
                                            if (!suretyBondReceivedDate || IsDateInFuture(suretyBondReceivedDate)) {
                                                //
                                                setSuretyBondValidationError(true);
                                                return;
                                            }

                                            if (sectionKey === "brokerRegulatoryInformationMap") {
                                                if (
                                                    isMortgageMainAgentTypeApplication(
                                                        applicationTypeFromLicenceSubType(queueItem.licencingSubType)
                                                    )
                                                ) {
                                                    dispatch(setConfirmSuretyBond(suretyBondReceivedDate));
                                                } else {
                                                    dispatch(
                                                        setCurrentAgentRegulatoryInformationReceivedDate(
                                                            suretyBondReceivedDate
                                                        )
                                                    );
                                                }
                                            } else {
                                                dispatch(setConfirmSuretyBond(suretyBondReceivedDate));
                                            }

                                            onReviewStatusChange(
                                                sectionKey,
                                                {
                                                    ...item2,
                                                    ...Object.defineProperty({ review: "complete" }, objKey, {
                                                        value: suretyBondReceivedDate,
                                                        enumerable: true,
                                                        writable: true
                                                    })
                                                },
                                                1
                                            );
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {item3 && (
                    <ReviewForm
                        data={item3}
                        review={item3.review}
                        isReadOnly={isReadOnly}
                        onStatusChange={(updatedItem) => onReviewStatusChange(sectionKey, updatedItem, 2)}
                    />
                )}
            </>
        );
    }

    const suretyBondRenewalSectionComponent = (sectionKey, reviewItem) => {
        let components = []
        let suretyBondReview

        reviewItem.forEach((d) => {
            if (d.type === CONST.DOCUMENT_TYPE_SURETY_BONDS) {
                let component = null

                if ("filename" in d) {
                    component = documentComponent(d)
                } else {
                    component = emptyDocument()
                }

                if (component) {
                    components.push(component)
                    suretyBondReview = d.review
                }
            }
        })

        return (
            <>
                <ReviewForm
                    data={{ "Supporting documents": components }}
                    review={suretyBondReview}
                    isReadOnly={isReadOnly}
                    showConfirmation={0 && isRenewalApplication}
                    confirmationMessage={`Is the ${sectionTitle(sectionKey)} section complete and correct?`}
                    onStatusChange={(updatedItem) => {
                        let reviewedDocs = reviewItem.map(d => {
                            if (d.type === CONST.DOCUMENT_TYPE_SURETY_BONDS) {
                                return {
                                    ...d,
                                    review: updatedItem.review
                                }
                            } else {
                                return d
                            }
                        })

                        onReviewStatusChange(sectionKey, reviewedDocs)
                    }}
                />
            </>
        )
    }

    const brokerReviewComponent = (sectionKey, reviewItems) => {
        const reviewData = [];

        let title = "Uploaded document"
        if (sectionKey === "brokerLicenceHistoryMap") {
            title = "Work history uploaded file"
        } else if (sectionKey === "brokerEducationRequirementMap") {
            title = "Certificate of completion"
        }

        reviewItems.forEach((reviewItem, reviewItemIndex) => {
            if (Object.hasOwnProperty.call(reviewItem, "document")) {
                const docComponent = documentComponent(reviewItem)

                const documentObj = { [title]: docComponent }

                reviewData.push(
                    <ReviewForm
                        key={reviewItem.id}
                        documentData={reviewItem}
                        data={documentObj}
                        review={reviewItem.review}
                        isReadOnly={isReadOnly}
                        onStatusChange={(updatedItem) => {
                            const updatedReviewItem = {
                                ...reviewItem,
                                review: updatedItem.review
                            }
                            onReviewStatusChange(sectionKey, updatedReviewItem, reviewItemIndex)
                        }}
                    />
                )
            } else {
                reviewData.push(
                    <ReviewForm
                        data={reviewItem}
                        review={reviewItem.review}
                        isReadOnly={isReadOnly}
                        onStatusChange={(updatedItem) => {
                            onReviewStatusChange(sectionKey, updatedItem, reviewItemIndex)
                        }}
                    />
                )
            }
        })

        return reviewData
    }

    const additionalBranchesRenewalSectionComponent = (sectionKey, reviewItems) => {
        const components = []

        const parseData = convertAdditionalBranchRenewalDataFromServer(reviewItems)

        const {
            additionalBranchData,
            renewedBranchData,
            notRenewedBranchData
        } = parseData

        if (additionalBranchData &&
            Array.isArray(additionalBranchData) &&
            additionalBranchData.length
        ) {
            components.push(
                <>
                    <h4>Branches added :</h4>
                    {additionalBranchData.map((app, index) => (
                        <>
                            <ReviewForm
                                data={app}
                                review={null}
                                hideDecisionCheckbox={false}
                                isReadOnly={isReadOnly}
                                showConfirmation={0 && !renewedBranchData.length && !notRenewedBranchData.length}
                                confirmationMessage={`Is the ${sectionTitle(sectionKey)} section complete and correct?`}
                                onStatusChange={(updatedItem) => {
                                    onReviewStatusChange(sectionKey, updatedItem)
                                }}
                            />
                            {index < additionalBranchData.length - 1 ? <SubSeparator /> : null}
                        </>
                    ))}
                </>)
        }

        if (renewedBranchData &&
            Array.isArray(renewedBranchData) &&
            renewedBranchData.length
        ) {
            const renewedBranchesComponents = []

            renewedBranchData.forEach((dataChanges, index) => {
                renewedBranchesComponents.push(
                    <>
                        <BLTChangeReviewForm
                            data={dataChanges}
                            reviewKey={sectionKey}
                            review={null}
                            showChangesTitle={index === 0}
                            showConfirmation={0 && !notRenewedBranchData.length}
                            confirmationMessage={`Is the ${sectionTitle(sectionKey)} section complete and correct?`}
                            onStatusChange={updatedItem => {
                                onReviewStatusChange(sectionKey, updatedItem)
                            }}
                        />
                        {(index < renewedBranchesComponents.length - 1) ? <SubSeparator /> : null}
                    </>)
            })

            if (components.length > 0) {
                components.push(<SubSeparator />)
            }

            components.push(
                <>
                    <h4>Branches renewed :</h4>
                    {renewedBranchesComponents}
                </>)
        }

        if (notRenewedBranchData &&
            Array.isArray(notRenewedBranchData) &&
            notRenewedBranchData.length
        ) {
            if (components.length > 0) {
                components.push(<SubSeparator />)
            }

            components.push(
                <>
                    <h4>Branches not renewed :</h4>
                    {notRenewedBranchData.map((app, index) => (
                        <>
                            <ReviewForm
                                data={app}
                                review={null}
                                hideDecisionCheckbox={false}
                                isReadOnly={isReadOnly}
                                showConfirmation={0 && isRenewalApplication}
                                confirmationMessage={`Is the ${sectionTitle(sectionKey)} section complete and correct?`}
                                onStatusChange={(updatedItem) => {
                                    onReviewStatusChange(sectionKey, updatedItem)
                                }}
                            />
                            {index < notRenewedBranchData.length - 1 ? <SubSeparator /> : null}
                        </>
                    ))}
                </>)
        }

        if (!components.length) {
            let noDataReview = null
            let showDecisionCheckbox = false
            if (reviewItems.length > 0) {
                showDecisionCheckbox = true
                noDataReview = reviewItems[0].review
            }

            components.push(
                <ReviewForm
                    data={[]}
                    review={noDataReview}
                    hideDecisionCheckbox={!showDecisionCheckbox}
                    isReadOnly={isReadOnly}
                    showConfirmation={0 && isRenewalApplication}
                    confirmationMessage={`Is the ${sectionTitle(sectionKey)} section complete and correct?`}
                    onStatusChange={(updatedItem) => {
                        onReviewStatusChange(sectionKey, updatedItem)
                    }}
                />
            )
        }

        return components
    }

    const handleNewAgentSendEmailClick = (emailAddress) => {
        setNewAgentEmailAddress(emailAddress);
        setShowModalDialog(true);
    }

    const changeRequestNewAgentEmailComponent = (sectionKey, reviewItems) => {
        const reviewData = [];

        const sendEmailComponent = (emailAddress) =>
            <Button
                style={{ margin: "10px 0" }}
                buttonType="regular_primary"
                text="Send Link"
                onClick={() => handleNewAgentSendEmailClick(emailAddress)}
            />;

        reviewItems.forEach((reviewItem, reviewItemIndex) => {
            let reviewComponent = {}

            for (const key in reviewItem) {
                if (key !== 'review') {
                    const value = reviewItem[key]
                    reviewComponent = {
                        ...reviewComponent,
                        [key]: <>{value}<br />{sendEmailComponent(value)}</>
                    }
                }
            }

            reviewData.push(
                <ReviewForm
                    data={reviewComponent}
                    review={reviewItem.review}
                    isReadOnly={isReadOnly}
                    onStatusChange={(updatedItem) => {
                        onReviewStatusChange(sectionKey, {
                            ...reviewItem,
                            review: updatedItem.review
                        }, reviewItemIndex)
                    }}
                />
            )
        })

        return reviewData;
    }

    const [sectionShown, setSectionShown] = useState({})

    const isForChangeRequest = reviewItem => (
        Object.hasOwnProperty.call(reviewItem, "changeFrom") &&
        Object.hasOwnProperty.call(reviewItem, "changeTo")
    )

    const individualReviewItem = (key, reviewItem) => {
        switch (key) {
            case 'documentsDataMap':
                return documentsSectionComponent(key, reviewItem)
            case 'suretyBondDataMap':
                if (isRenewalApplication) {
                    return suretyBondRenewalSectionComponent(key, reviewItem)
                } else {
                    return suretyBondSectionComponent(key, reviewItem)
                }
            case 'criminalRecordsCheckInformationMap':
                return criminalRecordsCheckComponent(key, reviewItem)
            case 'insuranceInformationMap':
                return insuranceRecordsComponent(key, reviewItem, isRenewalApplication)
            case 'airInformationMap':
                return airInformationComponent(key, reviewItem, isRenewalApplication)
            case 'confirmationInformationMap':
            case 'brokerConfirmationInformationMap':
                return confirmationComponent(key, reviewItem, isRenewalApplication)
            case 'brokerLicenceHistoryMap':
            case 'brokerEducationRequirementMap':
            case 'brokerCriminalRecordCheckMap':
                return brokerReviewComponent(key, reviewItem)
            case 'brokerRegulatoryInformationMap':
                return brokerSuretyBondSectionComponent(key, reviewItem)
            case 'changeRequestNewAgentEmailMap':
                return changeRequestNewAgentEmailComponent(key, reviewItem)
            case 'updatedDocumentsMap':
                return updatedDocumentsComponent(key, reviewItem);
            // case 'cancelLicenceInformationMap':
            //     return cancelLicenceInformationMap(key, reviewItem);

            default:
                if (!isBranchApplication(queueItem) && key === "additionalBranchesMap" && isRenewalApplication)
                    return additionalBranchesRenewalSectionComponent(key, reviewItem)

                return (
                    reviewItem.map((item, reviewItemIndex) => {
                        let hideDecisionCheckbox = false;
                        let showChangeForm = isForChangeRequest(item)
                        if (key === "applicantInformationMap") {
                            hideDecisionCheckbox = Object.keys(item).some((itemKey) => applicantInformationMapRJSC[itemKey])
                            // Avoid change for renewal licence when withdrawn is submitted
                            if(queueItem.licenceStatus !== CONST.LICENCE_STATUS_ACTIVE && queueItem.applicationStatus !== CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT) {
                                showChangeForm = isRenewalApplication
                            }
                        }

                        if (key === "decisionMap") {
                            return decisionSectionComponent(key, item)
                        } else if (key === "internalNotesMap") {
                            return internalNotesSectionComponents(key, item)
                        } else {
                            return (
                                showChangeForm ?
                                    <BLTChangeReviewForm
                                        data={[item]}
                                        reviewKey={key}
                                        review={item.review}
                                        showChangesTitle={reviewItemIndex === 0}
                                        showConfirmation={0 && (reviewItemIndex === (reviewItem.length - 1))}
                                        confirmationMessage={`Is the ${sectionTitle(key)} section complete and correct?`}
                                        isReadOnly={isReadOnly}
                                        onStatusChange={(updatedItem) => {
                                            onReviewStatusChange(key, updatedItem, reviewItemIndex)
                                        }}
                                    />
                                    : <ReviewForm
                                        data={item}
                                        review={item.review}
                                        hideDecisionCheckbox={hideDecisionCheckbox}
                                        isReadOnly={isReadOnly}
                                        showConfirmation={0 && isRenewalApplication}
                                        confirmationMessage={`Is the ${sectionTitle(key)} section complete and correct?`}
                                        onStatusChange={(updatedItem) => onReviewStatusChange(key, updatedItem, reviewItemIndex)}
                                    />
                            )
                        }
                    })
                )
        }
    }

    const reviewListElements = () => {
        let listElements = []
        let keys = sectionsOrder

        if (!keys || !keys.length) {
            return null
        }

        keys.forEach((key, index) => {
            const reviewItem = reviewDataCollectionDebt[key]
            if (reviewItem && Array.isArray(reviewItem)) {
                listElements.push(
                    <li className="timeline-item col-md-12">
                        <div className={classNameForListItem(index)}>
                            <span
                                className={[
                                    "step-counter",
                                    (index + 1 > 9 ? "step-counter-circle-2d" : "step-counter-circle"),
                                    sectionCompletenessClass(key)
                                ].join(" ")}
                            >
                                {index + 1}
                            </span>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <h3>{sectionTitle(key)}</h3>
                                <button
                                    id="section-toggle-button"
                                    className="btn btn-primary"
                                    data-toggle="collapse"
                                    data-target={"#" + key}
                                    aria-expanded="false"
                                    aria-controls={key}
                                    onClick={() => { expandSection(key, !sectionShown[key]) }}
                                >
                                    {sectionShown[key] ? "Hide" : "Show"}
                                </button>
                            </div>
                            <div className="collapse" id={key}>
                                {individualReviewItem(key, reviewItem)}
                            </div>
                            {index + 1 < keys.length ? <MainSeparator /> : null}
                        </div>
                    </li>
                )
            }
        })

        return listElements
    }

    const MainSeparator = () => {
        return (
            <hr
                className="bottomMarginNormal"
                style={{ borderColor: "#777", borderWidth: '3px' }}
            />
        )
    }

    const expandSection = (section, toggle) => {
        setSectionShown((prevSection) => ({ ...prevSection, [section]: toggle }))
    }

    const classNameForListItem = (index) => {
        let classes = ["step-content", "col-md-12", "col-xs-12"]

        if (index + 1 >= sectionsOrder.length)
            classes.push("step-content-no-border")
        return classes.join(" ")
    }

    const statusComponent = () => {
        return <ApplicationStatusComponent applicationStatus={queueItem.applicationStatus} />
    }

    if (!queueItem || !reviewDataCollectionDebt) {
        console.log("either queueItem or reviewDataCollectionDebt is empty")
        return null
    }

    const goBackToQueue = () => {
        dispatch(resetQueue());
        if (props.history?.goBack) {
            props.history.goBack()
        }
    }

    const onLicenceWithdrawBack = () => {
        setShowLicenceWithdrawView(false);
    }

    const onUpgradeWithdrawBack = () => {
        setShowUpgradeWithdrawView(false);
    }

    const onAgentApplicationApprovalViewBack = () => {
        setShowAgentApplicationApprovalView(false);
    }

    const proceedLicenceTransfer = (oldApplication) => {
        if (
            (CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION ||
                CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION) && oldApplication) {
            approveAndCancelApplication(oldApplication);
        }
    }

    const handleSendMessage = () => {

        if (messageRequestStatus === CONST.REQUEST_STATUS.IN_PROGRESS)
            return

        if (!emailMessageText) {
            setValidationError(true)
            setErrorString(ERROR_STRING.BLT_DECISION_NO_MESSAGE)
            return
        }

        const contactEmail = newAgentEmailAddress
        if (!contactEmail) {
            setValidationError(true)
            setErrorString(ERROR_STRING.BLT_DECISION_NO_EMAIL)
            return
        }

        setValidationError(false)

        const payloadData = {
            toEmail: [contactEmail],
            subject: "New Application Link",
            body: emailMessageText
        }

        setMessageRequestStatus(CONST.REQUEST_STATUS.IN_PROGRESS)
        props.dispatch(sendEmail(payloadData))
            .then(d => {
                setMessageRequestStatus(CONST.REQUEST_STATUS.SUCCESS)
            })
            .catch(err => {
                setMessageRequestStatus(CONST.REQUEST_STATUS.ERROR)
                setValidationError(true)
                setErrorString(ERROR_STRING.BLT_REVIEW_DECISION_MESSAGE_DELIVERY_FAIURE)
            })
            .finally(() => {
                setShowModalDialog(false);
            })
    }

    if (showLicenceWithdrawView) {
        return (
            <>
                <BLTNavigationTop />
                <LicenceWithdrawalConfirmation
                    onBack={onLicenceWithdrawBack}
                    bltReviewHandleContinue={handleContinue}
                    proceedLicenceTransfer={proceedLicenceTransfer}
                    onCancel={goBackToQueue}
                />
            </>
        )
    }

    if (showAgentApplicationApprovalView) {
        return (
            <>
                <BLTNavigationTop />
                <AgentApplicationApprovalConfirmation
                    onBack={onAgentApplicationApprovalViewBack}
                    bltReviewHandleContinue={handleContinue}
                    onCancel={goBackToQueue}
                />
            </>
        )
    }

    if (showUpgradeWithdrawView) {
        return (
            <>
                <BLTNavigationTop />
                <LicenceUpgradeWithdrawConfirmation
                    licenceUpgradeApplicationId={queueItem.businessLicenceData.licenceUpgradeApplicationId}
                    onBack={onUpgradeWithdrawBack}
                    bltReviewHandleContinue={handleContinue}
                    onCancel={goBackToQueue}
                />
            </>
        )
    }



    return (
        <>
            <BLTNavigationTop />
            <div className={"container"}>
                <BLTScreenNavigation
                    {...props}
                    onWillGoBack={() => {
                        dispatch(resetQueue());
                    }}
                />
                <div className="row bottomMarginMedium">
                    <h1>{mainTitle(queueItem)}</h1>
                </div>
                <div className="row">
                    <div className="col-lg-8">
                        <div className="row">
                            <span className="bltReview-businessName">{mediumTitle(queueItem)}</span>
                        </div>
                        <div className="row">
                            <span className="bltReview-legalName">{legalNameTitle(queueItem)}</span>
                        </div>
                        <div className="row">
                            <span className="bltReview-contactPersonName">{subTitle(queueItem)}</span>
                        </div>
                    </div>
                    <div className="col-lg-2">
                        <div className="row">
                            <h4>Current Status</h4>
                        </div>
                        <div className="row">
                            {statusComponent()}
                        </div>
                    </div>
                </div>

                <div className="timeline row topMarginMedium">
                    <div className="col-lg-10 bltReviewList">
                        <ol>
                            {reviewListElements()}
                        </ol>
                    </div>
                </div>

                <DocumentViewer
                    fileData={documentViewerDocument}
                    isOpen={openDocumentViewer}
                    fileName={selectedFile?.filename}
                    handleClose={() => setOpenDocumentViewer(false)}
                />

                <Modal
                    appElement={document.getElementById('root')}
                    isOpen={showModalDialog}
                    contentLabel="editDetailsDialog"
                    onRequestClose={() => { setShowModalDialog(false) }}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    className="modalDialogContent sendEmailModalDialog"
                    closeTimeoutMS={150}
                >
                    <div style={{ margin: "20px" }}>
                        <div className="row">
                            <div className="col-lg-12">
                                <b>Email Address : </b> {newAgentEmailAddress}
                            </div>
                        </div>
                        <div className="row topMarginNormal">
                            <div className="col-lg-12">
                                <b>Message : </b>
                                <textarea
                                    id={"email-message-input"}
                                    rows={4}
                                    value={emailMessageText}
                                    onInput={e => setEmailMessageText(e.target.value)}>
                                </textarea>
                            </div>
                        </div>
                        <div className="row topMarginNormal">
                            <div className={"col-lg-3" + (validationError ? " has-error" : "")}>
                                <Button
                                    showSpinner={messageRequestStatus === CONST.REQUEST_STATUS.IN_PROGRESS}
                                    buttonType="regular_primary"
                                    text="Send Email"
                                    onClick={handleSendMessage}
                                    id="blt-decision-summary-send-message"
                                />
                                {validationError && ErrorMark()}
                                {validationError && <div className="help-block">
                                    {errorString}
                                </div>}
                            </div>
                            <div className="col-lg-3">
                                <Button
                                    buttonType="regular_primary"
                                    text={"Cancel"}
                                    onClick={() => {
                                        setShowModalDialog(false);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    )
}

export default connect(bltReviewSelect)(BLTReview)
